<template>
  <v-container fluid>
    <v-layout justify-center align-center>
      <v-flex md10>
        <DataTableMain :datatable="table" :on-success="btnAction" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMainLocal'
// import dialogFormCaract from ''
export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'toCreate', code: 'libre', hidden: '' }
        ],
        titles: [
          // { text: 'ID', value: 'id', class: 'black--text' },
          { text: 'Nombre Tipo Dato', value: 'nombre', class: 'black--text' },
          { text: 'Estructura Json', value: 'FieldJson', class: 'black--text', action: 'showfieldJson', field: 'default' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ]
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    formulario: {
      fields: [
        {
          type: 'text',
          name: 'Nombre',
          nameid: 'nombre',
          field: 'text',
          cols: 12
        },
        {
          url: '/tipo-datos',
          name: 'Tipo de datos',
          nameid: 'tipo_dato_id',
          field: 'selectDataServer',
          cols: 12
        }
      ]
    }
  }),
  components: {
    DataTableMain
  },
  mounted () {
    this.getDataUrl('td.list')
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlGetServicesActionList']),
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.urlGetServicesActionList({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    btnAction (action) {
      if (action.title === 'Nuevo') {
        this.toCreate()
      }
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getDataUrl('td.list')
    },
    toCreate () {
      this.SHOW_DIALOG_MAIN({ type: 'create', withWindows: 800, title: 'Agregar Caracteristica' })
    },
    ...mapMutations(['CLEAR_OBJECTS', 'SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects'])
  },
  watch: {
    get_urls (val) {
      this.getDataUrl('td.list')
    },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        this.table.header.loading = false
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }
}
</script>
